import NaptimeResource from './NaptimeResource';

class onDemandCourseForumStatistics extends NaptimeResource {
  static RESOURCE_NAME = 'onDemandCourseForumStatistics.v1';
}

export default onDemandCourseForumStatistics;
